export enum DeviceTypesEnum {
  scale = 1,
  printer = 2,
}
